module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Analogico-HF-5.466b302f.png";